import { NextSeo } from 'next-seo';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Markdown } from '@/components/Markdown';
import { Content } from '@/components/templatePage/content';
import { Header } from '@/components/templatePage/header';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import markdownText from '@/utils/staticMarkdowns/privacyPolicy';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <NextSeo
        title={t('privacyPolicy.title')}
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/terms-of-use`,
        }}
      />
      <Layout>
        <Header title={t('privacyPolicy.title')} />
        <Content>
          <Markdown source={markdownText} />
        </Content>
      </Layout>
    </Fragment>
  );
};

export default PrivacyPolicy;
